import { useEffect, useState } from "react"
import { Id, toast } from "react-toastify"
import { showLoadingToast } from "../utils/utils"

const useLoadingToast = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [loadingToastId, setLoadingToastId] = useState<Id|undefined>(undefined)

  useEffect(() => {
    if (!isLoading && loadingToastId !== undefined) {
      toast.done(loadingToastId)
    }
  }, [isLoading, loadingToastId])

  /**
   * Shows a loading toast.
   * 
   * @param message to render on loading toast.
   */
  const onShow = (message: string) => {
    setIsLoading(true)
    setLoadingToastId(showLoadingToast(message))
  }

  /**
   * Hides the loading toast.
   */
  const onHide = () => {
    setIsLoading(false)
  }

  return [{
    onShow,
    onHide
  }]
}

export default useLoadingToast